import { trackEvent } from './mixpanel';

export const trackSubscriptionUpgradeClicked = (source: 'home_page' | 'subscription_page'): void => {
  trackEvent('Subscription Flow - Upgrade Clicked', {
    source,
  });
};

export const trackSubscriptionPurchased = (): void => {
  trackEvent('Subscription Flow - Purchased', {});
};

export const trackAppointmentFlowStarted = (): void => {
  trackEvent('Appointment Flow - Started', {});
};

export const trackAppointmentClientSelected = (clientId: string): void => {
  trackEvent('Appointment Flow - Client Selected', {
    clientId,
  });
};

export const trackAppointmentServiceSelected = (serviceId: string): void => {
  trackEvent('Appointment Flow - Service Selected', {
    serviceId,
  });
};

export const trackAppointmentTimeSelected = (slotId: string): void => {
  trackEvent('Appointment Flow - Time Selected', {
    slotId,
  });
};

export const trackAppointmentCompleted = (properties: {
  clientId: string;
  serviceIds: string[];
  appointmentId?: string;
  totalDuration?: number;
  totalPrice?: number;
}): void => {
  trackEvent('Appointment Flow - Completed', properties);
};
